import React from "react";
import { useTranslation } from "react-i18next";
import Level from "../../../../../common/level/Level";
import { cutShort } from "../../../../../utils/stringUtil";
import Divider from "../../../../../common/divider/Divider";
import Box from "../../../../../common/box/Box";
import { select } from "../PreviewDocumentsUtils";
import { format } from "date-fns";

function Letters({ state, url, setSelected }) {
  const { t } = useTranslation();

  return (
    <>
      {state.letters.length > 0 && (
        <>
          <div className="block">
            <Divider label={t("requests.reviewDocuments.letter.divider")} />

            {state.letters.map((letter, index) => (
              <Box
                key={"detail" + index}
                statusIndicatorPosition="left"
                statusIndicatorColor={letter.color === null ? "warning" : letter.color}
                className="is-size-5"
              >
                <Level>
                  <Level.Side align="left">
                    {index + 1}. {cutShort(letter.title, 130, "...")}
                    {" - "}
                    {format(new Date(letter.submissionDate), "dd.MM.yyyy")}
                  </Level.Side>
                  <Level.Side align="right">
                    <Level>
                      <Level.Side align="right" className="is-flex">
                        <button
                          onClick={() => select("letters", index, null, null, setSelected)}
                          /* to={{
                            pathname: `${url}/letters/${index}`,
                            state: { state },
                          }} */
                          rel="noopener noreferrer"
                          className="button is-pulled-left"
                        >
                          {t("requests.reviewDocuments.letter.preview")}
                        </button>
                      </Level.Side>
                    </Level>
                  </Level.Side>
                </Level>
              </Box>
            ))}
            <Divider label={t("requests.reviewDocuments.letter.attachments")} />

            {state.letters.map((letter, lindex) => (
              <div key={lindex}>
                {letter.additionalDocs.map((additionalDoc, index) => (
                  <Box
                    key={"detail" + index}
                    statusIndicatorPosition="left"
                    statusIndicatorColor={
                      additionalDoc.color === null ? "warning" : additionalDoc.color
                    }
                    className="is-size-5"
                  >
                    <Level>
                      <Level.Side align="left">
                        {index + 1}. {cutShort(additionalDoc.label, 130, "...")}
                      </Level.Side>
                      <Level.Side align="right">
                        <Level>
                          <Level.Side align="right" className="is-flex">
                            <button
                              onClick={() =>
                                select("letters", lindex, "additionalDocs", index, setSelected)
                              }
                              /* to={{
                                pathname: `${url}/letters/${lindex}/additionalDocs/${index}`,
                                state: { state },
                              }} */
                              rel="noopener noreferrer"
                              className="button is-pulled-left"
                            >
                              {t("requests.reviewDocuments.letter.preview")}
                            </button>
                          </Level.Side>
                        </Level>
                      </Level.Side>
                    </Level>
                  </Box>
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}

export default Letters;
